import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/Profile.css';

const Profile = () => {
    const [user, setUser] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    // Function to fetch profile data from the backend
    const fetchProfile = async () => {
        try {
            const token = sessionStorage.getItem('token');
            if (!token) {
                setError("No active session. Please log in again.");
                setLoading(false);
                return;
            }

            const res = await axios.get('http://localhost:5000/api/profile', {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            setUser(res.data);
            setLoading(false);
        } catch (err) {
            console.error("Profile fetch error:", err);
            setError(err.response?.data?.error || "Failed to load profile.");
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProfile();
    }, []);

    // Trigger the hidden file input
    const handleChangeClick = () => {
        document.getElementById('profilePageInput').click();
    };

    // Handle image upload and database update
    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('profilePic', file);

        try {
            const token = sessionStorage.getItem('token');
            const res = await axios.put('http://localhost:5000/api/auth/profile-pic', formData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (res.data.profile_pic) {
                // 1. Update Session Storage so App.js/Sidebar sees the change
                const storedUser = JSON.parse(sessionStorage.getItem('user') || '{}');
                const updatedUser = { ...storedUser, profile_pic: res.data.profile_pic };
                sessionStorage.setItem('user', JSON.stringify(updatedUser));

                // 2. Update local state to show image immediately on this page
                setUser(prev => ({ ...prev, profile_pic: res.data.profile_pic }));


                // 3. Optional: reload to force a global sync across all components
                window.location.reload();
            }
        } catch (err) {
            console.error("Upload failed:", err);
            alert("Upload failed. Please try again.");
        }
    };

    if (loading) return <div className="profile-status">Loading your profile...</div>;
    if (error) return <div className="profile-status error">{error}</div>;

    return (
        <div className="profile-page-container">
            <div className="profile-card">
                <div className="profile-header">
                    <div className="avatar-circle" style={{ overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {user.profile_pic ? (
                            <img 
                                src={`http://localhost:5000${user.profile_pic}`} 
                                alt="Profile" 
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                            />
                        ) : (
                            <div className="profile-initial">
                                {user.username ? user.username.charAt(0).toUpperCase() : '?'}
                            </div>
                        )}
                    </div>

                    {/* Change Profile Picture Button */}
                    <button className="change-pic-btn" onClick={handleChangeClick}>
                        Change Profile Picture
                    </button>
                    
                    {/* Hidden File Input */}
                    <input 
                        type="file" 
                        id="profilePageInput" 
                        style={{ display: 'none' }} 
                        accept="image/*" 
                        onChange={handleFileChange} 
                    />

                    <h2>{user.username}</h2>
                    <p className="user-role">Connect Member</p>
                </div>

                <div className="profile-details">
                    <div className="detail-group">
                        <label>Email Address</label>
                        <div className="detail-value">{user.email}</div>
                    </div>

                    <div className="detail-group">
                        <label>Member Since</label>
                        <div className="detail-value">
                            {user.memberSince ? new Date(user.memberSince).toLocaleDateString() : 'N/A'}
                        </div>
                    </div>

                    <div className="detail-group">
                        <label>Projects Joined</label>
                        <div className="detail-value">{user.joinedCount || 0} Projects</div>
                    </div>

                    <div className="detail-group">
                        <label>Projects Created</label>
                        <div className="detail-value">{user.createdCount || 0} Projects</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Profile;